import { Fade } from 'react-reveal';
import React from 'react';

import Carousel from '../components/carousel';
import Col from '../components/col';
import FadeCounter from '../components/fadeCounter';
import ImageSplit from '../components/imageSplit';
import ImageTextSplit from '../components/imageTextSplit';
import ParallaxImage from '../components/parallaxImage';
import Section from '../components/section';
import Map from '../components/map';
import majorPinFallback from "../images/logo.svg"
import minorPinFallback from "../images/map-pin.svg"
import styled from "styled-components"

export const renderSections = (sections, skipAnchor=false) => (
  <React.Fragment>
    {!!sections && sections.map((section, s) => {
      const { items } = section;

      switch( section.slice_type ) {
        case 'feature_section':
          let { primary: { show_divider: showDivider, background, color, content: { html: content }, title: { html: title }, image, wrap } } = section;

          return (
            <Section key={s} background={background} color={color} padded wrap={wrap || "small"} height="20em" center>
              <Col>
                <Fade bottom distance="20px">
                  <div>
                    {!!image && !!image.url && (<img src={image.url} {...image.dimensions} alt={image.alt} />)} 
                    {showDivider === 'Yes' && <hr />}
                    <div dangerouslySetInnerHTML={{ __html: (title || "") + content }} />
                  </div>
                </Fade>
              </Col>
            </Section>
          );

        case 'fade_counter_row':
          return (
            <Section key={s} padded flex>
              {items.map(({
                after: { text: after },
                decimal_places: decimalPlaces,
                thousands_separator: thousands,
                prefix,
                suffix,
                final_value: value,
                start_value: from 
              }, i) => (
                <Col key={i} center>
                  <p>
                    <FadeCounter 
                      from={from} 
                      value={value} 
                      format={value => `${prefix||""}${value.toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, thousands ? "," : "")}${suffix||""}`} 
                      duration={2000} 
                    />
                    <span>{after}</span>
                  </p>
                </Col>
              ))}
            </Section>
          )
          
        case 'full_width_image':
          const { primary: { effect, image: { alt, dimensions, url }, caption: { text: caption } } } = section
          return (
            <Fade key={s}>
              <ImageWrapper>
                {effect === "None" ? <img src={url} {...dimensions} alt={alt} /> : <ParallaxImage src={url} {...dimensions} />}
                {!!caption && <Caption>{caption}</Caption>}
              </ImageWrapper>
            </Fade>
          );

        case 'image_text_split':
          return (
            <React.Fragment key={s}>
              {items.map(({ 
                attribution: { text: attribution },
                background,
                color,
                image: { alt, url }, 
                content: { html: content }, 
                header: { html: header },
                // quote: { html: quote },
                // source: { text: source },
                decimal_places: decimalPlaces,
                thousands_separator: thousands,
                prefix,
                suffix,
                value,
                start_value: from 
              }, i) => {
                if( !background ) 
                  background = i % 2 ? "#FFFFFF" : "#F0F0F0"
                return (
                  <ImageTextSplit key={i} background={background} color={color} image={url} alt={alt} position={i % 2 ? "right" : "left"}>
                    {!!header && <div dangerouslySetInnerHTML={{ __html: header }} />}
                    {!!content && <div dangerouslySetInnerHTML={{ __html: content }} />}
                    {!!value && ( <FadeCounter 
                        from={from} 
                        value={value} 
                        format={value => `${prefix||""}${value.toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, thousands ? "," : "")}${suffix||""}`} 
                        duration={3000} 
                      />
                    )}
                    {/* {!!quote && <blockquote className="h2" dangerouslySetInnerHTML={{ __html: quote }} />} */}
                    {/* {!!source && <cite className="h3"><strong>{source.split(" ", 2)[0]}</strong> {source.split(" ", 2)[1]}</cite>} */}
                    {!!attribution && <cite>{attribution}</cite>}

                  </ImageTextSplit>
                )
              })}
            </React.Fragment>
          );

        case 'carousel':
          return (
            <Fade key={s}>
              <Carousel>
                {items.map(({ image: { dimensions, url, alt } }, i) => <img key={i} src={url} alt={alt} {...dimensions} />)}
              </Carousel>
            </Fade>
          );

        case 'map':
          const {
            primary: {
              main_location: mainLocation,
              major_location_pin: majorLocationPin,
              minor_location_pin: minorLocationPin,
            }
          } = section;

          let locations = [];

          items.forEach(({ name, type, point }) => {
            if ( ! ( type in locations ) ) {
              locations[type] = {
                type,
                points: [],
              }
            }

            locations[type].points.push({
                name,
                lat: point.latitude,
                lng: point.longitude
            })
          })

          locations = Object.values(locations)

          return (
            <Fade key={s}>
              <Map 
                locations={locations} 
                mainLocation={{
                  lat: mainLocation.latitude,
                  lng: mainLocation.longitude
                }} 
                majorPin={ majorLocationPin.url ?? majorPinFallback }
                minorPin={ minorLocationPin.url ?? minorPinFallback }
              />
            </Fade>
          )

        case '50_50_image_split':
          const { primary: { left_image, right_image } } = section
          return <ImageSplit key={s} left_image={left_image} right_image={right_image} />

        case 'quote_section':
          if( true ) {
            const { primary: { background, color, quote: { text: quote }, source: { text: source }, wrap } } = section;
            return (
              <Section key={s} background={background} color={color} padded wrap={wrap || "small"} height="20em" center>
                <Col>
                  <Fade bottom distance="20px">
                    <div>
                      <blockquote className="h2">{quote}</blockquote>
                      {source && (<cite className="h5">{source}</cite>)}
                    </div>
                  </Fade>
                </Col>
              </Section>
            )
          }
          break;


        default:
          return null;
      }

      return null
    })}
  </React.Fragment>
)



const Caption = styled.p`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  color: #FFF;
  font-size: 10px;
`

const ImageWrapper = styled.div`
  position: relative;
`
